function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "8"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4 8a1 1 0 01-.707-.293l-3-3a1 1 0 111.414-1.414l2.226 2.226L8.233.36a1 1 0 011.538 1.28l-5 6a1 1 0 01-.724.359z",
  fill: "#51bb7b"
})));